import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import cx from 'classnames';
import SiteHeader from '../../includes/SiteHeader';
import Button from '../common/ButtonComponent';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import { clearBCSID } from '../../utils/BiocatchUtils';

class NonBCustomerError extends Component {
  constructor(props) {
    super(props);
    this.goToB = this.goToB.bind(this);
  }

  componentWillMount() {
    SiteHeaderActionCreator.setSideBarFlag(false);
  }

  componentDidMount() {
    sayLandingMessage(
      this.props.headerContent
        ? this.props.headerContent
        : 'Non B Customer Error'
    );
    clearBCSID();
  }

  goToB() {
    const { sessionTimeout, componentName, handleButtonClick2 } = this.props;
    if (sessionTimeout) {
      NavigateToWebApps.navigateToLoginPage();
    } else if (componentName) {
      handleButtonClick2();
    } else {
      window.location.href = 'https://www.youandb.co.uk/';
    }
  }

  showBCBYBlinks() {
    return (
      <div>
        <p>
          <a href="http://www.cbonline.co.uk/">Visit Clydesdale Bank</a>
        </p>
        <p>
          <a href="http://www.ybonline.co.uk/">Visit Yorkshire Bank</a>
        </p>
        <p>
          <a href="https://www.youandb.co.uk/">Visit B</a>
        </p>
      </div>
    );
  }

  render() {
    const {
      page,
      headerFlag,
      watchContent,
      headerContent,
      bodyContent1,
      bodyContent2,
      hideButton1,
      buttonName2,
      buttonClass2,
    } = this.props;
    return (
      <div className="bow">
        <Helmet title="Accounts" />
        <div
          className={cx('c-site-header__stacked', {
            nonbcustomer: !headerFlag,
          })}
        >
          <SiteHeader />
          <div className="container" id="site-main" role="main" tabIndex="-1">
            <div className="row">
              <div className={cx('pagelevel-error errorpage-scroll', { page })}>
                <div className="c-step-header--app-error u-text-center">
                  <div className="c-step-title">
                    {watchContent}
                    {headerContent && <h2>{headerContent}</h2>}
                  </div>
                  <p>
                    {bodyContent1} <br /> {bodyContent2}
                  </p>
                  {!hideButton1 ? (
                    this.showBCBYBlinks()
                  ) : (
                    <Button
                      btnName={buttonName2}
                      className={buttonClass2}
                      onClick={this.goToB}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NonBCustomerError.propTypes = {
  mediaClass: PropTypes.string,
  headerContent: PropTypes.string,
  bodyContent1: PropTypes.string,
  bodyContent2: PropTypes.string,
  buttonName2: PropTypes.string,
  buttonClass2: PropTypes.string,
  hideButton1: PropTypes.bool,
  sessionTimeout: PropTypes.bool,
  headerFlag: PropTypes.bool,
  componentName: PropTypes.bool,
  watchContent: PropTypes.string,
  page: PropTypes.bool,
};

NonBCustomerError.defaultProps = {
  headerContent: '',
  bodyContent1:
    'Sorry, it looks like you’ve logged in to the wrong internet banking service.',
  bodyContent2:
    'Please go to the website of the brand you bank with (Clydesdale Bank, Yorkshire Bank or B) and log in to internet banking there.',
  buttonName2: 'Get to know B',
  buttonClass2: 'c-btn c-btn--default',
  sessionTimeout: false,
  headerFlag: false,
  componentName: false,
  hideButton1: false,
  watchContent: '',
  page: false,
};

export default NonBCustomerError;
